// @flow
import type {
  RequestResetPasswordOperator,
} from '../types'

// Operator Composer
import composeOperator from 'fc-operations'

// Exports
export default function getRequestResetOperator (): RequestResetPasswordOperator {
  return composeOperator({
    model: 'RequestResetPassword',
    branch: 'requestResetOperation',
  })
}
